import { useEffect } from 'react';
import { createHook, createStore } from 'react-sweet-state';
import ProfileClient from '@atlaskit/profilecard/client';
import { useAppConfig } from '../app-config-context';
const CACHE_MAX_AGE = 60 * 1000;
const actions = {
  createClient: (stargateRoot, enableTeamCentral = false) => ({
    setState
  }) => {
    const profileClient = new ProfileClient({
      gatewayGraphqlUrl: `${stargateRoot}/graphql`,
      url: `${stargateRoot}/directory/graphql`,
      teamCentralUrl: enableTeamCentral ? `${stargateRoot}/watermelon/graphql` : undefined,
      // teamCentralBaseUrl: enableTeamCentral
      //   ? getConfig().teamCentralUrl
      //   : undefined,
      cacheSize: 20,
      cacheMaxAge: CACHE_MAX_AGE
    });
    setState({
      profileClient
    });
    return profileClient;
  }
};
const ProfileClientStore = createStore({
  initialState: {},
  actions
});
const useProfileClientState = createHook(ProfileClientStore);
export const useProfileClient = () => {
  // const [teamCentralStore] = useTeamCentralStore();
  const [{
    profileClient
  }, {
    createClient
  }] = useProfileClientState();
  const {
    stargateRoot
  } = useAppConfig();
  useEffect(() => {
    createClient(stargateRoot);
  }, [createClient, stargateRoot]);

  // TODO: enable team central
  // useEffect(() => {
  //   if (teamCentralStore.hasWorkspace || teamCentralStore.orgHasWorkspace) {
  //     // re-create the client and enable team central features
  //     createClient(true);
  //   }
  // }, [teamCentralStore.hasWorkspace, teamCentralStore.orgHasWorkspace]);

  return profileClient;
};